module.exports = __webpack_public_path__ + "img/sport_soccer.fa904aa6.png";